import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { ROUTES } from "~/utils/routing/routeUtils";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Slim setup walkthrough tour for Property Table — focus on Add Property.
 */
export const propertyTableSetupTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Setup_PropertyTable_Title"),
    description: t("Tour_Setup_PropertyTable_Description"),
    target: () => queryTourTarget("add-property-button"),
    placement: "left",
    recommendedTours: [
      {
        label: t("Tour_Setup_Next_AddProperty"),
        path: ROUTES.addProperty,
      },
    ],
  },
];
